// extracted by mini-css-extract-plugin
export default {"preview":"asset_preview__igOCg","file":"asset_file__4TEts","image":"asset_image__OAIBy","info":"asset_info__LwpeP","errorMessage":"asset_errorMessage__wKB7D"};